export const PROFILE_IMAGE_SIZE = 'profileFontSize';
export const NAME_FONT_SIZE = 'nameFontSize';
export const IMAGE_SIZE = 'imageSize';
export const IMAGE_BORDER_RADIUS = 'imageBorderRadius';
export const DESIGNATION_FONT_SIZE = 'designationFontSize';
export const ICON_SIZE = 'iconSize';
export const ICON_BORDER_RADIUS = 'iconBorderRadius';
export const ICON_GAP = 'iconGap';
export const ICON_ROUND_SIZE = 'iconRoundSize';
export const QR_POSITION_HORIZONTAL = 'qrPositionHorizontal';
export const QR_POSITION_VERTICAL = 'qrPositionVertical';
export const ABOUT_TITLE_FONT_SIZE = 'aboutTitleFontSize';
export const ABOUT_TITLE_ICON_FONT_SIZE = 'aboutTitleIconFontSize';
export const ABOUT_DESCRIPTION_FONT_SIZE = 'aboutDescriptionFontSize';
export const DATE_OF_BIRTH_FONT_SIZE = 'dateOfBirthFontSize';
export const NATIONALITY_FONT_SIZE = 'nationalityFontSize';
export const CONTACT_FONT_SIZE = 'contactFontSize';
export const SKILL_TITLE_FONT_SIZE ='skillTitleFontSize';
export const SKILL_TITLE_ICON_FONT_SIZE ='skillTitleIconFontSize';
export const SKILL_NAME_FONT_SIZE ='skillNameFontSize';
export const SKILL_PERCENTAGE_FONT_SIZE ='skillPercentageFontSize';
export const LANGUAGE_TITLE_FONT_SIZE ='languageTitleFontSize';
export const LANGUAGE_TITLE_ICON_FONT_SIZE ='languageTitleIconFontSize';
export const LANGUAGE_NAME_FONT_SIZE ='languageNameFontSize';
export const LANGUAGE_PERCENTAGE_FONT_SIZE ='languagePercentageFontSize';
export const HOBBY_TITLE_FONT_SIZE ='hobbyTitleFontSize';
export const HOBBY_TITLE_ICON_FONT_SIZE ='hobbyTitleIconFontSize';
export const HOBBY_NAME_FONT_SIZE ='hobbyNameFontSize';
export const HOBBY_ICON_FONT_SIZE ='hobbyIconFontSize';
export const HOBBY_ITEM_GAP ='hobbyItemGap';
export const EDUCATION_TITLE_FONT_SIZE ='educationTitleFontSize';
export const EDUCATION_TITLE_ICON_FONT_SIZE ='educationTitleIconFontSize';
export const STUDY_FIELD_FONT_SIZE ='studyFieldFontSize';
export const EDUCATION_DEGREE_NAME_FONT_SIZE ='degreeNameFontSize';
export const EDUCATION_DESCRIPTION_FONT_SIZE ='educationDescriptionFontSize';
export const EDUCATION_DATE_FONT_SIZE ='educationDateFontSize';
export const INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE ='institutionCityCountryNameFontSize';
export const EDUCATION_PASSING_YEAR_FONT_SIZE ='educationPassingYearFontSize';
export const EXPERIENCE_TITLE_FONT_SIZE ='experienceTitleFontSize';
export const EXPERIENCE_TITLE_ICON_FONT_SIZE ='experienceTitleIconFontSize';
export const EXPERIENCE_COMPANY_FONT_SIZE ='experienceCompanyFontSize';
export const EXPERIENCE_DESIGNATION_FONT_SIZE ='experienceDesignationFontSize';
export const EXPERIENCE_DESCRIPTION_FONT_SIZE ='experienceDescriptionFontSize';
export const EXPERIENCE_DATE_FONT_SIZE ='experienceDateFontSize';
export const REFERENCE_TITLE_FONT_SIZE ='referenceTitleFontSize';
export const REFERENCE_NAME_FONT_SIZE ='referenceNameFontSize';
export const REFERENCE_JOB_POSITION_FONT_SIZE ='referenceJobPositionFontSize';
export const REFERENCE_COMPANY_FONT_SIZE ='referenceCompanyFontSize';
export const REFERENCE_PHONE_FONT_SIZE ='referencePhoneFontSize';
export const REFERENCE_RELATION_FONT_SIZE ='referenceRelationFontSize';
export const ABOUT_PADDING_TOP = 'aboutPaddingTop';
export const ABOUT_PADDING_RIGHT = 'aboutPaddingRight';
export const ABOUT_PADDING_BOTTOM = 'aboutPaddingBottom';
export const ABOUT_PADDING_LEFT = 'aboutPaddingLeft';
export const ABOUT_BORDER_RADIUS_TOP = 'aboutBorderRadiusTop';
export const ABOUT_BORDER_RADIUS_RIGHT = 'aboutBorderRadiusRight';
export const ABOUT_BORDER_RADIUS_BOTTOM = 'aboutBorderRadiusBottom';
export const ABOUT_BORDER_RADIUS_LEFT = 'aboutBorderRadiusLeft';
export const CONTACT_PADDING_TOP = 'contactPaddingTop';
export const CONTACT_PADDING_RIGHT = 'contactPaddingRight';
export const CONTACT_PADDING_BOTTOM = 'contactPaddingBottom';
export const CONTACT_PADDING_LEFT = 'contactPaddingLeft';
export const CONTACT_BORDER_RADIUS_TOP = 'contactBorderRadiusTop';
export const CONTACT_BORDER_RADIUS_RIGHT = 'contactBorderRadiusRight';
export const CONTACT_BORDER_RADIUS_BOTTOM = 'contactBorderRadiusBottom';
export const CONTACT_BORDER_RADIUS_LEFT = 'contactBorderRadiusLeft';
export const SKILL_PADDING_TOP = 'skillPaddingTop';
export const SKILL_PADDING_RIGHT = 'skillPaddingRight';
export const SKILL_PADDING_BOTTOM = 'skillPaddingBottom';
export const SKILL_PADDING_LEFT = 'skillPaddingLeft';
export const SKILL_BORDER_RADIUS_TOP = 'skillBorderRadiusTop';
export const SKILL_BORDER_RADIUS_RIGHT = 'skillBorderRadiusRight';
export const SKILL_BORDER_RADIUS_BOTTOM = 'skillBorderRadiusBottom';
export const SKILL_BORDER_RADIUS_LEFT = 'skillBorderRadiusLeft';
export const LANGUAGE_PADDING_TOP = 'languagePaddingTop';
export const LANGUAGE_PADDING_RIGHT = 'languagePaddingRight';
export const LANGUAGE_PADDING_BOTTOM = 'languagePaddingBottom';
export const LANGUAGE_PADDING_LEFT = 'languagePaddingLeft';
export const LANGUAGE_BORDER_RADIUS_TOP = 'languageBorderRadiusTop';
export const LANGUAGE_BORDER_RADIUS_RIGHT = 'languageBorderRadiusRight';
export const LANGUAGE_BORDER_RADIUS_BOTTOM = 'languageBorderRadiusBottom';
export const LANGUAGE_BORDER_RADIUS_LEFT = 'languageBorderRadiusLeft';
export const HOBBY_PADDING_TOP = 'hobbyPaddingTop';
export const HOBBY_PADDING_RIGHT = 'hobbyPaddingRight';
export const HOBBY_PADDING_BOTTOM = 'hobbyPaddingBottom';
export const HOBBY_PADDING_LEFT = 'hobbyPaddingLeft';
export const HOBBY_BORDER_RADIUS_TOP = 'hobbyBorderRadiusTop';
export const HOBBY_BORDER_RADIUS_RIGHT = 'hobbyBorderRadiusRight';
export const HOBBY_BORDER_RADIUS_BOTTOM = 'hobbyBorderRadiusBottom';
export const HOBBY_BORDER_RADIUS_LEFT = 'hobbyBorderRadiusLeft';
export const EDUCATION_PADDING_TOP = 'educationPaddingTop';
export const EDUCATION_PADDING_RIGHT = 'educationPaddingRight';
export const EDUCATION_PADDING_BOTTOM = 'educationPaddingBottom';
export const EDUCATION_PADDING_LEFT = 'educationPaddingLeft';
export const EDUCATION_BORDER_RADIUS_TOP = 'educationBorderRadiusTop';
export const EDUCATION_BORDER_RADIUS_RIGHT = 'educationBorderRadiusRight';
export const EDUCATION_BORDER_RADIUS_BOTTOM = 'educationBorderRadiusBottom';
export const EDUCATION_BORDER_RADIUS_LEFT = 'educationBorderRadiusLeft';
export const EXPERIENCE_PADDING_TOP = 'experiencePaddingTop';
export const EXPERIENCE_PADDING_RIGHT = 'experiencePaddingRight';
export const EXPERIENCE_PADDING_BOTTOM = 'experiencePaddingBottom';
export const EXPERIENCE_PADDING_LEFT = 'experiencePaddingLeft';
export const EXPERIENCE_BORDER_RADIUS_TOP = 'experienceBorderRadiusTop';
export const EXPERIENCE_BORDER_RADIUS_RIGHT = 'experienceBorderRadiusRight';
export const EXPERIENCE_BORDER_RADIUS_BOTTOM = 'experienceBorderRadiusBottom';
export const EXPERIENCE_BORDER_RADIUS_LEFT = 'experienceBorderRadiusLeft';
export const REFERENCE_PADDING_TOP = 'referencePaddingTop';
export const REFERENCE_PADDING_RIGHT = 'referencePaddingRight';
export const REFERENCE_PADDING_BOTTOM = 'referencePaddingBottom';
export const REFERENCE_PADDING_LEFT = 'referencePaddingLeft';
export const REFERENCE_BORDER_RADIUS_TOP = 'referenceBorderRadiusTop';
export const REFERENCE_BORDER_RADIUS_RIGHT = 'referenceBorderRadiusRight';
export const REFERENCE_BORDER_RADIUS_BOTTOM = 'referenceBorderRadiusBottom';
export const REFERENCE_BORDER_RADIUS_LEFT = 'referenceBorderRadiusLeft';
export const ABOUT_SECTION_PADDING_TOP = 'aboutSectionPaddingTop';
export const ABOUT_SECTION_PADDING_RIGHT = 'aboutSectionPaddingRight';
export const ABOUT_SECTION_PADDING_BOTTOM = 'aboutSectionPaddingBottom';
export const ABOUT_SECTION_PADDING_LEFT = 'aboutSectionPaddingLeft';
export const CONTACT_SECTION_PADDING_TOP = 'contactSectionPaddingTop';
export const CONTACT_SECTION_PADDING_RIGHT = 'contactSectionPaddingRight';
export const CONTACT_SECTION_PADDING_BOTTOM = 'contactSectionPaddingBottom';
export const CONTACT_SECTION_PADDING_LEFT = 'contactSectionPaddingLeft';
export const SKILL_SECTION_PADDING_TOP = 'skillSectionPaddingTop';
export const SKILL_SECTION_PADDING_RIGHT = 'skillSectionPaddingRight';
export const SKILL_SECTION_PADDING_BOTTOM = 'skillSectionPaddingBottom';
export const SKILL_SECTION_PADDING_LEFT = 'skillSectionPaddingLeft';
export const SKILL_BAR_GAP = 'skillBarGap';
export const LANGUAGE_SECTION_PADDING_TOP = 'languageSectionPaddingTop';
export const LANGUAGE_SECTION_PADDING_RIGHT = 'languageSectionPaddingRight';
export const LANGUAGE_SECTION_PADDING_BOTTOM = 'languageSectionPaddingBottom';
export const LANGUAGE_SECTION_PADDING_LEFT = 'languageSectionPaddingLeft';
export const LANGUAGE_BAR_GAP = 'languageBarGap';
export const HOBBY_SECTION_PADDING_TOP = 'hobbySectionPaddingTop';
export const HOBBY_SECTION_PADDING_RIGHT = 'hobbySectionPaddingRight';
export const HOBBY_SECTION_PADDING_BOTTOM = 'hobbySectionPaddingBottom';
export const HOBBY_SECTION_PADDING_LEFT = 'hobbySectionPaddingLeft';
export const EDUCATION_SECTION_PADDING_TOP = 'educationSectionPaddingTop';
export const EDUCATION_SECTION_PADDING_RIGHT = 'educationSectionPaddingRight';
export const EDUCATION_SECTION_PADDING_BOTTOM = 'educationSectionPaddingBottom';
export const EDUCATION_SECTION_PADDING_LEFT = 'educationSectionPaddingLeft';
export const EXPERIENCE_SECTION_PADDING_TOP = 'experienceSectionPaddingTop';
export const EXPERIENCE_SECTION_PADDING_RIGHT = 'experienceSectionPaddingRight';
export const EXPERIENCE_SECTION_PADDING_BOTTOM = 'experienceSectionPaddingBottom';
export const EXPERIENCE_SECTION_PADDING_LEFT = 'experienceSectionPaddingLeft';
export const REFERENCE_SECTION_PADDING_TOP = 'referenceSectionPaddingTop';
export const REFERENCE_SECTION_PADDING_RIGHT = 'referenceSectionPaddingRight';
export const REFERENCE_SECTION_PADDING_BOTTOM = 'referenceSectionPaddingBottom';
export const REFERENCE_SECTION_PADDING_LEFT = 'referenceSectionPaddingLeft';
export const HEADER_PADDING_TOP = 'headerPaddingTop';
export const HEADER_PADDING_RIGHT = 'headerPaddingRight';
export const HEADER_PADDING_BOTTOM = 'headerPaddingBottom';
export const HEADER_PADDING_LEFT = 'headerPaddingLeft';
export const FOOTER_PADDING_TOP = 'footerPaddingTop';
export const FOOTER_PADDING_RIGHT = 'footerPaddingRight';
export const FOOTER_PADDING_BOTTOM = 'footerPaddingBottom';
export const FOOTER_PADDING_LEFT = 'footerPaddingLeft';
export const ITEM_BORDER_RADIUS_TOP = 'itemBorderRadiusTop';
export const ITEM_BORDER_RADIUS_BOTTOM = 'itemBorderRadiusBottom';
export const ITEM_PADDING_TOP = 'itemPaddingTop';
export const ITEM_PADDING_RIGHT = 'itemPaddingRight';
export const ITEM_PADDING_BOTTOM = 'itemPaddingBottom';
export const ITEM_PADDING_LEFT = 'itemPaddingLeft';
export const WRAPPER_BORDER_RADIUS = 'wrapperBorderRadius';
export const WRAPPER_PADDING_BOTTOM = 'wrapperPaddingBottom';
export const WRAPPER_PADDING_TOP = 'wrapperPaddingTop';
export const WRAPPER_PADDING_LEFT = 'wrapperPaddingLeft';
export const WRAPPER_PADDING_RIGHT = 'wrapperPaddingRight';
export const WRAPPER_MARGIN_TOP = 'wrapperMarginTop';
export const WRAPPER_MARGIN_BOTTOM = 'wrapperMarginBottom';
export const WRAPPER_MARGIN_LEFT = 'wrapperMarginLeft';
export const WRAPPER_MARGIN_RIGHT = 'wrapperMarginRight';
export const WRAPPER_BORDER_RADIUS_TOP = 'wrapperBorderRadiusTop';
export const WRAPPER_BORDER_RADIUS_RIGHT = 'wrapperBorderRadiusRight';
export const WRAPPER_BORDER_RADIUS_BOTTOM = 'wrapperBorderRadiusBottom';
export const WRAPPER_BORDER_RADIUS_LEFT = 'wrapperBorderRadiusLeft';







